import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  margin-bottom: 4px;
  padding: 0.75rem 1.5rem 0.5rem 1.5rem;

  @media (max-width: 768px) {
    padding: 0.5rem 1rem 0.25rem 1rem;
  }
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;

  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
  }
`;

export const TitleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.8125rem;
  height: 1.8125rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.interfaceBackground};
  color: ${({ theme }) => theme.colors.interfaceText400};
`;

export const TitleText = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceText400};
  margin: 0;
`;


export const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.interfaceGray300};
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Value = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.interfaceText400};
  line-height: 1.4;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props: any) => props.theme.colors.ce0e0e0};
  margin: 1.5rem 0 0 0;
`; 